// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__7B579","spinner-aib1d7":"Loader_spinner-aib1d7__9e3Vb"};